import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
    CircularProgress,
} from '@deere/fuel-react';
import React, { useEffect, useState } from 'react';
import Configuration from '@deere/ux.brand-foundations/icons/configuration.svg';
import TaskList from '@deere/ux.brand-foundations/icons/task_list.svg';
import archive from '@deere/ux.brand-foundations/icons/archive.svg';
import { useNavigate } from 'react-router-dom';
import styles from '../Admin/Home.module.css';
import { useOktaAuth } from '@okta/okta-react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AlertBox } from '../../components/AlertBox';
import { useContext } from 'react';
import { WorkforceContext } from '../../context/WorkforceContext.jsx';
import { DateTime } from 'luxon';

export const WorkforceHome = () => {
    const { authState } = useOktaAuth();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(375));
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const { loading, activeJobBids } = useContext(WorkforceContext);

    useEffect(() => {
        if (
            activeJobBids &&
            activeJobBids[0] &&
            DateTime.fromISO(activeJobBids[0].endDate) < DateTime.now() &&
            DateTime.fromISO(activeJobBids[0].bidWithDrawalEndDt) >
                DateTime.now()
        ) {
            // in withdrawal phase
            setShowAlert(true);
        }
    }, [activeJobBids]);

    return (
        <div className={styles.homeContainer}>
            <Grid container spacing={6} style={{ maxWidth: '80%' }}>
                {loading && (
                    <CircularProgress
                        size="lg"
                        variant="indeterminate"
                        title={'Loading'}
                    />
                )}
                {!loading && showAlert && (
                    <AlertBox
                        variant="info"
                        msg="You have job bids in the Bid Withdrawal Period! If you would like to withdraw any of your current bids, go to My Job Bids and click on the job to view job details and withdraw your bid."
                        handleClose={() => setShowAlert(false)}
                    />
                )}
                <Grid item xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                <Typography
                                    gutterBottom
                                    variant="h1"
                                    component="h1"
                                    color="#367C2B"
                                >
                                    Welcome{' '}
                                    {authState.accessToken.claims.firstName}{' '}
                                    {authState.accessToken.claims.lastName}!
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                During a job bid Active period, you can bid on
                                open jobs. After a job closes, you can view
                                where you fall on the seniority list of bidders
                                for that job and withdraw your bid during the
                                Bid Withdrawal period. Once the withdrawal
                                period is over, the job will be assigned to a
                                successful bidder(s).
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                {matches && (
                                    <img
                                        alt=">>"
                                        src={Configuration}
                                        className={styles.svgIcon}
                                    />
                                )}
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                >
                                    Active Job Openings
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                View and bid on current open job bids.
                                <br />
                                <br />
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() =>
                                        navigate('/active-job-openings')
                                    }
                                >
                                    View Current Job Openings
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                {matches && (
                                    <img
                                        alt=">>"
                                        src={TaskList}
                                        className={styles.svgIcon}
                                    />
                                )}
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                    size="large"
                                >
                                    My Job Bids
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                View all my current job bids. Withdraw my bids
                                during the withdrawal period.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/my-job-bids')}
                                >
                                    View My Current Job Bids
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                {matches && (
                                    <img
                                        alt=">>"
                                        //src={Note}
                                        src={archive}
                                        className={styles.svgIcon}
                                    />
                                )}
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                    size="large"
                                >
                                    My Bid History
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="small"
                                paddingTop="0.50rem"
                            >
                                View all the jobs you have bid on in past job
                                bid cycles.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/my-bid-history')}
                                >
                                    View My Bid History
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};
